import { Component } from '@angular/core';
import { AdminBreadcrumbsService } from '../admin-services/admin-breadcrumbs.service';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';
import { getReportRoute, ReportKey } from '../admin-services/report-routes.config';
import { LifecycleEnrollmentService } from '../admin-services/lifecycle-enrollment.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.css']
})
export class AdminHomeComponent {
  userName: string = 'Admin User';

  constructor(
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private masterService: MasterDataSeriveService,
    private lifecycleEnrollmentService: LifecycleEnrollmentService,
    private router: Router
  ) {}

  ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Dashboard', link: '/admin/home/admin-home' },
    ]);
    this.userName = this.masterService.getUserDetailsFromStorage().userName || 'Admin User';
  }

  private navigateToReport(reportKey: ReportKey) {
    this.lifecycleEnrollmentService.isEnrolled$().subscribe((isEnrolled) => {
      this.router.navigate([getReportRoute(reportKey, isEnrolled)]);
    });
  }

  navigateToSellThroughReport() {
    this.navigateToReport('sellThrough');
  }

  navigateToEmpReport() {
    this.navigateToReport('empReport');
  }

  navigateToSalePerProducerReport() {
    this.navigateToReport('salePerProducer');
  }

  navigateToTopPerformer() {
    this.navigateToReport('topPerformer');
  }

  navigateToProductionOverview() {
    this.navigateToReport('productionOverview');
  }
}
